import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Popover from 'components/common/Popover'
import Icon from 'components/common/Icon/Icon'
import Theme from 'components/common/Theme/Theme'
import { TOOLTIPS } from 'components/common/Popover/constants'
import {
  Cell,
  PriceCell,
  ItemText,
  SubTitle,
  Title,
  PopoverContainer,
  PopoverInnerContent
} from './CommonStyles'


const TPPItem = ({
  price = 0,
  brand: name,
  handlePopoverClick,
  genericId,
  label
}) =>
  <Table htmlFor={ genericId }>
    <Cell width="80">
      <Content>
        <Title>
          <ItemText><Bolder>FREE</Bolder> TIRE PROTECTION PLAN</ItemText>
          <PopoverContainer onClick={ handlePopoverClick }>
            <Popover
              centered
              components={{ PopoverInnerContent }}
              info={ TOOLTIPS[name] }
              small
              data-at-tpms-tooltip />
          </PopoverContainer>
          <DiamondIcon alt="" asset="diamond-green" />
        </Title>
        <SubTitle>{ label }</SubTitle>
      </Content>
    </Cell>
    <PriceCell width="20">
      ${price.toFixed(2)}
    </PriceCell>
  </Table>

TPPItem.propTypes = {
  brand: PropTypes.string,
  genericId: PropTypes.string,
  handlePopoverClick: PropTypes.func,
  label: PropTypes.string,
  price: PropTypes.number
}

export default TPPItem


const Table = styled.label`
  position: relative;
  margin-bottom: 10px;
  overflow-x: hidden;
  padding: 5px 0;
  display: table;
  table-layout: fixed;
  width: 100%;
  border-bottom: 1px solid ${Theme.colors.light_grey};
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding-top: 3px;
`

const Bolder = styled.span`
  font-weight: 700;
  font-style: italic;
`

const DiamondIcon = styled(Icon)`
  margin: -5px 0 0 -5px;
  width: 15px;
  height: 17px;
`
